<template>
  <b-dropdown :disabled="items.length < 2" v-bind="$attrs">
    <slot>
      <slot name="search">
        <div v-if="showSearch">
          <b-dropdown-form>
            <b-form-input
              v-model.lazy="search"
              :placeholder="$t('general.search')"
              size="sm"
              type="search"
            ></b-form-input>
          </b-dropdown-form>
          <b-dropdown-divider />
        </div>
      </slot>

      <slot name="items">
        <div>
          <b-dropdown-item
            v-for="item in filtered"
            :key="item.id"
            :active="item.isActive"
            @click="$emit('click:item', item)"
          >
            {{ item.label }}
          </b-dropdown-item>
        </div>
      </slot>
    </slot>
  </b-dropdown>
</template>

<script>
export default {
  name: 'NavbarDropdown',

  props: {
    showSearch: {
      type: Boolean,
      default: false,
    },

    items: {
      type: Array,
      required: true,
    },

    searchFilter: {
      type: Function,
      default: function (item, search) {
        return item.label.toLowerCase().indexOf(search.toLowerCase()) !== -1
      },
    },
  },

  data() {
    return {
      search: '',
    }
  },

  computed: {
    filtered() {
      return this.items.filter((item) => this.searchFilter(item, this.search))
    },
  },
}
</script>
